import React from 'react';

const PageLoader = ({ text = 'Loading data...' }) => (
  <div className="page-loader-wrap">
    <div className="page-loader-box">
      <div className="pl-spinner">
        <div className="pl-ring pl-ring-1"></div>
        <div className="pl-ring pl-ring-2"></div>
        <div className="pl-ring pl-ring-3"></div>
      </div>
      <p className="pl-text">{text}</p>
    </div>
  </div>
);

export default PageLoader;
